import UpdatePseudoForm from '@features/games/profile/change-pseudo-form/change-pseudo-form';
export default UpdatePseudoForm;
